import LikeEmoji from "_components/molecules/likeEmoji";

const component = ( { reactions, RxnMap } ) => {
	const maxCount     = 5;
	const allReactions = Object.keys ( reactions );

	const rxnComps = allReactions.map ( ( reaction, index ) => {
		return (
			<LikeEmoji
				key   = { index }
				count = { Math.min ( reactions[reaction]?.showCount || 0, maxCount ) }
				name  = { RxnMap[reaction]?.name }
				src   = { RxnMap[reaction]?.src }
				total = { reactions[reaction]?.previousCount || 0 }
			/>
		);
	} );

	return (
		<>
			{rxnComps}
		</>
	);

};

export default component;
